<script setup lang="ts">
// Arms itself only while signed in; anonymous visitors are unaffected.
import SessionTimeoutGuard from '@/components/SessionTimeoutGuard.vue'
</script>

<template>
    <RouterView />
    <SessionTimeoutGuard />
</template>
